import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#navigation',
			dom: {
				click: '.js-navigation-click',
				step: '.js-navigation-step'
			},
			classes: {
				active: 'navigation__step_state_active'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		return this;
	}

	get() {
		const {click, step} = this.options.dom;

		this.$click = this.$el.find(click);
		this.$step = this.$el.find(step);

		return this;
	}

	onSet = (event, set) => {
		const $tagret = this.$step.filter('[data-name="' + set + '"]');
		if ($tagret.length) {
			const {active} = this.options.classes;

			$tagret.addClass(active);
			this.$step.not($tagret).removeClass(active);
			this.$window.trigger('navigation.set', [$tagret.data('name')]);
		}
	}

	onClick(event) {
		const $tagret = $(event.currentTarget);
		if (!$tagret.hasClass(this.options.classes.active)) {
			this.$window.trigger('navigation.setup', [$tagret.data('name')]);
		}
		event.preventDefault();
	}

	init() {
		this.$window.on('navigation.setup', this.onSet.bind(this));
		this.$click.on('click', this.onClick.bind(this));
	}

	render() {
		if (this.$el.length) {
			this
				.get()
				.init();
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/navigation/navigation.js